import React from "react";
import classes from './ServiseMarksDocumet.module.scss'
import Document from "../../../../components/Document";
export default function ServiseMarksDocumet() {
    return(
        <Document/>

    )
    
}